import OrdersIndex from '@/views/carpetline/orders/Index'
import OrdersDetail from '@/views/carpetline/orders/Detail'
import OrdersForm from '@/views/carpetline/orders/Form'
import UserCustomerRelationsIndex from '@/views/carpetline/usercustomerrelations/Index'
import UserCustomerRelationsForm from '@/views/carpetline/usercustomerrelations/Form'
import UserCustomerRelationsDetail from '@/views/carpetline/usercustomerrelations/Detail'

export default
[
    {
        name:`carpetline:index`,
        path:`/carpetline`,
        component: {
            template: '<div><router-view /></div>'
        },
        children: [
            {
                name:`orders:index`,
                path:`orders`,
                component: OrdersIndex
            },
            {
                name:`orders:create`,
                path: `orders/create`,
                component: OrdersForm
            },
            {
                name:`orders:update`,
                path: `orders/:orderId/update`,
                component: OrdersForm
            },
            {
                name: `orders:detail`,
                path: `orders/:orderId`,
                component: OrdersDetail
            },
            {
                name: `user-customer-relations:index`,
                path: `user-customer-relations`,
                component: UserCustomerRelationsIndex
            },
            {
                name: `user-customer-relations:create`,
                path: `user-customer-relations/create`,
                component: UserCustomerRelationsForm
            },
            {
                name: `user-customer-relations:detail`,
                path: `user-customer-relations/:userId`,
                component: UserCustomerRelationsDetail
            }
        ]
    }
]